import { render, staticRenderFns } from "./TrafficTrendChart.vue?vue&type=template&id=9a70f1ec"
import script from "./TrafficTrendChart.vue?vue&type=script&lang=js"
export * from "./TrafficTrendChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports